import { render } from "./WhyMobile.vue?vue&type=template&id=15431d63&scoped=true"
import script from "./WhyMobile.vue?vue&type=script&lang=js"
export * from "./WhyMobile.vue?vue&type=script&lang=js"

import "./WhyMobile.vue?vue&type=style&index=0&id=15431d63&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15431d63"]])

export default __exports__